import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Pia3TranscriptService {
  constructor() {}
}
